import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WebsiteBuilder from './WebsiteBuilder';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WebsiteBuilder />
  </React.StrictMode>
);
